import { render, staticRenderFns } from "./onlineUpload.vue?vue&type=template&id=6ca1a756&scoped=true"
import script from "./onlineUpload.vue?vue&type=script&lang=js"
export * from "./onlineUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1a756",
  null
  
)

export default component.exports